import script from "./BillInvoiceView.vue?vue&type=script&setup=true&lang=js"
export * from "./BillInvoiceView.vue?vue&type=script&setup=true&lang=js"

import "./BillInvoiceView.vue?vue&type=style&index=0&id=b76b5478&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b76b5478"]])

export default __exports__